import { render } from "./yto.html?vue&type=template&id=2bc5d0db&scoped=true&ts=true"
import script from "./yto.ts?vue&type=script&lang=ts"
export * from "./yto.ts?vue&type=script&lang=ts"

import "./yto.scss?vue&type=style&index=0&id=2bc5d0db&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc5d0db"]])

export default __exports__